import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { categories } from '../data/content';
export function WhatsInside() {
  return <section aria-labelledby="inside-heading" className="bg-paper py-16 sm:py-24" data-id="element-248" data-mp="kw7zx52hhunz">
      <Container data-id="element-249" data-mp="kylu7bpcb2uh">
        <SectionHeading id="inside-heading" eyebrow="One download. Endless things to build." title={<>
              <span className="text-clay" data-id="element-251" data-mp="b4vcqqrmrsoa">1,200+</span> 3D Paper Crafts
              <span className="block" data-id="element-252" data-mp="fxeqpou8cptm">for Every Kind of Imagination</span>
            </>} subtitle="No more searching for activities every afternoon. Choose a project, print it at home and start building." data-id="element-250" data-mp="pv2kock0htaq" />

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:mt-16 sm:grid-cols-2 lg:grid-cols-3" data-id="element-253" data-mp="752zi0rakycl">
          {categories.map(category => <li key={category.title} className="group flex flex-col overflow-hidden rounded-xl2 border border-hairline bg-white shadow-paper transition-shadow duration-200 hover:shadow-lift" data-id="element-254" data-mp="3tbrss2z8tb2i">
              <div className="relative" data-id="element-255" data-mp="37trrdcxsykit">
                <img src={category.image} alt={category.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-256" data-mp="37x762enkdrjp" />
                <span aria-hidden="true" className="absolute -bottom-6 left-5 flex h-12 w-12 items-center justify-center rounded-2xl border border-hairline bg-white text-[22px] shadow-paper" data-id="element-257" data-mp="2u3fvr420e3mx">
                  {category.emoji}
                </span>
              </div>

              <div className="flex flex-1 flex-col px-5 pb-6 pt-9 sm:px-6" data-id="element-258" data-mp="2y4hvrn3r2jpy">
                <h3 className="font-display text-[20px] font-bold leading-snug tracking-[-0.015em] text-ink" data-id="element-259" data-mp="2affg2ksof0y3">
                  {category.title}
                </h3>
                <p className="mt-2.5 text-[16px] leading-[1.6] text-muted" data-id="element-260" data-mp="26dliwmhowf2o">{category.description}</p>
              </div>
            </li>)}
        </ul>
      </Container>
    </section>;
}